import singleBidTransformer from './singleBidTransformer';

/**
 * Transforms bids
 * @param {array} bids
 * @returns {object[]} bids with the camelcase properties and conversionRate property added to it
 */
export default function bidsTransformer(bids) {
  if (!Array.isArray(bids)) {
    return [];
  }
  return bids.map(bid => singleBidTransformer(bid));
}
